import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { VarianceListing } from './Pages'

export const VarianceRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={VarianceListing} />
    </Fragment>
)